import * as Dialog from '@radix-ui/react-dialog';
import { useEffect, useState } from 'react';
import { useStore } from '@/state/store';
import { TEMPLATES } from '@/content/templates';
import { runTour } from '@/lib/tour';

/** Welcome modal on first run + a Help button to replay the tour (§10.8). */
export function Onboarding() {
  const onboardingComplete = useStore((s) => s.ui.onboardingComplete);
  const setUi = useStore((s) => s.setUi);
  const newBlank = useStore((s) => s.newBlank);
  const loadInputs = useStore((s) => s.loadInputs);
  const sofr = useStore((s) => s.sofrLatestRate);
  const taxProfile = useStore((s) => s.taxProfile);
  const loaded = useStore((s) => s.loaded);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loaded && !onboardingComplete) setOpen(true);
  }, [loaded, onboardingComplete]);

  const finish = () => {
    void setUi({ onboardingComplete: true });
    setOpen(false);
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/50" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[min(92vw,520px)] -translate-x-1/2 -translate-y-1/2 rounded-lg border border-slate-200 bg-white p-5 shadow-xl dark:border-slate-700 dark:bg-slate-800">
          <Dialog.Title className="text-lg font-bold">Welcome to the Securities-Backed Borrowing Dashboard</Dialog.Title>
          <Dialog.Description className="mt-2 text-sm text-slate-600 dark:text-slate-300">
            A securities-backed line of credit — like a Schwab Pledged Asset Line or Fidelity SBLOC — lets
            you borrow against your investments without selling them. Enter the base rate and spread your
            lender quoted and this tool models the cost, risk, and net-worth impact over time, then weighs
            borrowing against selling (the buy-borrow-die comparison). Education only, not financial advice.
          </Dialog.Description>
          <div className="mt-4 flex flex-col gap-2">
            <button
              type="button"
              className="rounded bg-sky-600 px-3 py-2 text-sm font-medium text-white hover:bg-sky-700"
              onClick={() => {
                finish();
                setTimeout(() => runTour(), 200);
              }}
            >
              Take the tour
            </button>
            <button
              type="button"
              className="rounded border border-slate-300 px-3 py-2 text-sm hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-700"
              onClick={() => {
                loadInputs(TEMPLATES[1]!.build(sofr, taxProfile), TEMPLATES[1]!.name);
                finish();
              }}
            >
              Load a starter scenario
            </button>
            <button
              type="button"
              className="rounded border border-slate-300 px-3 py-2 text-sm hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-700"
              onClick={() => {
                newBlank();
                finish();
              }}
            >
              Start blank
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

/** Help button that replays the tour. */
export function HelpButton() {
  return (
    <button
      type="button"
      onClick={() => runTour()}
      className="rounded-md border border-slate-300 px-2 py-1 text-sm hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800"
    >
      Help / Tour
    </button>
  );
}
